export enum DisplaySettingSection {
    Main = "main",
    Reports = "reports",
}

export interface DisplayTypeAdditional {
    type: string;
    title?: () => string;
    formatter?: (value: any, parent: any) => string | Array<string>;
    separator?: string;
    options?: Array<{ text: string; value: any }>;
    show?: boolean;
    always?: boolean;
    value?: any;
    group?: any;
    filter?: any;
    details?: any;
    orderBy?: any;
    descending?: boolean;
    notSelected?: boolean;
    global?: boolean;
    example?: string;
}

export interface DisplayTypeEntry {
    type?: string;
    order?: boolean;
    format?: number;
    value?: boolean;
}

export interface DisplayTypeSubjectAdditionals {
    faculty: string;
    yearLevel: string;
    subgrid: boolean;
    units: boolean;
    capping: boolean;
    gender: boolean;
    value: boolean;
    load: number;
}

export interface DisplayTypeStudentAdditionals {
    code: boolean;
    bosCode: boolean;
    gender: boolean;
    rollClass: boolean;
    yearLevel: boolean;
    house: boolean;
    homeGroup: boolean;
    webChoices: boolean;
    studentSparefield1: boolean;
    studentSparefield2: boolean;
    studentSparefield3: boolean;
    studentListsEmail: boolean;
}

export interface DisplayType {
    type: string;
    section: DisplaySettingSection;
    name?: string;
    codeField?: string;
    nameField?: string;
    additional?: Array<DisplayTypeAdditional> | undefined;
    titles?: DisplayTypeEntry | undefined;
    twoName?: DisplayTypeEntry | undefined;
    example?: (
        builder: (
            code: string,
            name1: string,
            name2?: string,
            name3?: string,
            title?: string,
        ) => string,
    ) => string;
    defaultType?: any;
    value: string;
    isResetFilter?: boolean;
}
